import { FC, ReactElement, useRef } from 'react';

import { Button, Card } from '../../../components';
import { Dialog, Loading } from '../../../compositions';
import { closeDialog, openDialog } from '../../../helpers/dialog';
import trans from '../../../helpers/trans';
import { DeleteAccountConfirmMessage } from './subcomponents';

import './DeleteAccountFormCard.scss';

interface DeleteAccountFormCardProps {
    isLoading: boolean;
    onDeleteConfirm: () => void;
    className?: string;
}

const DeleteAccountFormCard: FC<DeleteAccountFormCardProps> = ({
    isLoading,
    onDeleteConfirm,
    className = '',
}): ReactElement => {
    const dialogRef = useRef<HTMLDialogElement>(null);

    const handleOpenDialog = (): void => openDialog(dialogRef);
    const handleCloseDialog = (): void => closeDialog(dialogRef);

    const handleConfirmDeleteAccount = (): void => {
        onDeleteConfirm();
        handleCloseDialog();
    };

    return (
        <Card className={`delete-account-form-card ${className}`}>
            <h1 className="delete-account-form-card__title">
                {trans('forms.deleteAccount.title')}
            </h1>

            {isLoading && <Loading className="delete-account-form-card__loader" />}

            {!isLoading && (
                <div className="delete-account-form-card__wrapper">
                    <p className="delete-account-form-card__description">
                        {trans('forms.deleteAccount.description')}
                    </p>

                    <Button
                        text={trans('forms.deleteAccount.buttonLabel')}
                        onClick={handleOpenDialog}
                        className="delete-account-form-card__button"
                    />
                </div>
            )}

            <Dialog ref={dialogRef} onClose={handleCloseDialog}>
                <DeleteAccountConfirmMessage
                    onConfirm={handleConfirmDeleteAccount}
                    onCancel={handleCloseDialog}
                />
            </Dialog>
        </Card>
    );
};

export default DeleteAccountFormCard;
